import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { logCrossOriginFramedEvent } from "./lib/amplitude-utils";

const FramingContext = React.createContext({});

export const useFramingContext = () => React.useContext(FramingContext);

export const FrameRestricter = ({ children }) => {
  const [ displayBody, setIsDisplayBody ] = React.useState(
    window.self === window.top
  );
  const [ framingAllowed, setIsFramingAllowed ] = React.useState(false);
  React.useEffect(() => {
    async function handleBodyDisplay() {
      if (framingAllowed && window.self !== window.top) {
        await logCrossOriginFramedEvent({
          parentOrigin: document.referrer,
        });
      }
      if (window.self === window.top || framingAllowed) {
        setIsDisplayBody(true);
      }
    }
    handleBodyDisplay();
  }, [ framingAllowed ]);

  const framingContextProviderValue = useMemo(
    () => ({
      allowFraming: () => {
        setIsFramingAllowed(true);
      },
    }),
    []
  );

  return (
    <div style={{ display: displayBody ? "block" : "none" }}>
      <FramingContext.Provider value={framingContextProviderValue}>
        {children}
      </FramingContext.Provider>
    </div>
  );
};

FrameRestricter.propTypes = {
  children: PropTypes.node.isRequired,
};
